import { useAppKitAccount, useAppKitNetwork } from "@reown/appkit/react";
import axios from "axios";
import BigNumber from "bignumber.js";
import { ethers } from "ethers";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  RiArrowDownLine,
  RiArrowUpLine,
  RiExchangeDollarLine,
  RiExternalLinkLine,
  RiFileCopy2Line,
  RiTimer2Line,
  RiUser3Line,
  RiWalletLine,
} from "react-icons/ri";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { ClipboardCopy } from "../components/ClipboarCopy";
import { Footer, Header } from "../components/opencoin-ui";
import { useSupabase } from "../hooks/useSupabase";
import {
  useCheckIsNeedApprove,
  useDynamicCallFunction,
  useDynamicSendFunction,
  useGetERC20Detail,
} from "../hooks/web3hook";
import { getAppByChainId } from "../libs/Env";
import { copyToClipboard, formatNumericWithComma } from "../libs/utils";
import { truncate } from "../libs/WebooLib";

const TableRow = ({ tx, tokenDecimalUSDT }) => {
  const { address, isConnected } = useAppKitAccount();
  const { chainId } = useAppKitNetwork();
  const [{ isLoading: isLoadingDynamicCall }, dynamicCall] =
    useDynamicCallFunction();
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [dividend, setDividend] = useState("0");
  const [dividendInToken, setDividendInToken] = useState("0");
  useEffect(() => {
    if (!address) return;
    getPeriodStake();
  }, [address]);

  const getPeriodStake = () => {
    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "stakePeriodsIndex",
      [ethers.utils.getAddress(address), tx.id]
    ).then((res) => {
      //region get detail stake of period
      dynamicCall(
        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
        "getDetailStakePerPeriodOf",
        [ethers.utils.getAddress(address), res.toString()]
      ).then((res) => {
        console.log(res.toString());
        const start = moment.unix(res[0]).format("YYYY-MM-DD HH:mm:ss");
        const end = moment.unix(res[1]).format("YYYY-MM-DD HH:mm:ss");
        setStartAt(start.toString());
        setEndAt(end.toString());
      });
      //endregion

      //region get current reward of period
      dynamicCall(
        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
        "dividendOfPeriod",
        [ethers.utils.getAddress(address), res.toString()]
      ).then((res) => {
        const wei = new BigNumber(res.toString());
        const div = wei.dividedBy(10 ** (chainId === 97 ? 18 : 6));
        setDividend(div.toString());

        //region estimate in token
        dynamicCall(
          getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
          getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
          "getEstimateTokenAmount",
          [res.toString()]
        ).then((res) => {
          console.log("estimate", res.toString());
          const wei = new BigNumber(res.toString());
          const div = wei.dividedBy(10 ** 18);
          console.log("div", div.toString());
          setDividendInToken(
            ethers.utils.formatUnits(res.toString()).toString()
          );
          // console.log()
        });
      });
      //endregion
    });
  };
  return (
    <>
      <tr>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          {formatNumericWithComma(tx.amount, 10 ** (tokenDecimalUSDT || 6))}{" "}
          {tx.amount_symbol}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          {startAt}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          {endAt}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
          {truncate(tx.hash, 4, "...", 50)}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm justify-end flex flex-col gap-2 text-gray-900">
          <div className={"flex gap-2 justify-end"}>
            {dividend}
            <img src="/images/usdt.svg" width="20px" alt="usdt-small" />
          </div>
          <div class={"flex gap-2 justify-end"}>
            Est:
            {dividendInToken}
            <img
              src="/images/icon-reward/opc-coin.png"
              width="20px"
              alt="opencoin-small"
            />
          </div>
        </td>
      </tr>
    </>
  );
};

export default function OpcStakeLong() {
  const [transactions, setTransactions] = useState([]);
  const { chainId } = useAppKitNetwork();
  const { address, isConnected } = useAppKitAccount();
  const { t } = useTranslation();
  const [amountStake, setAmountStake] = useState(0);
  const [
    {
      tokenBalance: usdtBalance,
      tokenSymbol: tokenSymbolUSDT,
      tokenDecimal: tokenDecimalUSDT,
    },
    fetchTokenInfoUSDT,
    getUSDTBalance,
  ] = useGetERC20Detail();
  const [
    {
      tokenSymbol: tokenSymbolStake,
      tokenBalance: tokenBalanceStake,
      isLoadingTokenInfo: isLoadingTokenInfoStake,
    },
    fetchTokenInfoStake,
    getStakeBalance,
  ] = useGetERC20Detail();
  const [
    {
      tokenSymbol: tokenSymbolOpc,
      tokenBalance: tokenBalanceOpc,
      isLoadingTokenInfo: isLoadingTokenInfoOpc,
    },
    fetchTokenInfoOpc,
    getOpcBalance,
  ] = useGetERC20Detail();
  const [{ isLoading: isLoadingDynamicCall }, dynamicCall] =
    useDynamicCallFunction();
  const [{ result: resultSend, isLoading: isLoadingSend }, dynamicSend] =
    useDynamicSendFunction();
  const [minimumStakeInDollars, setMinimumStakeInDollars] = useState(0);
  const [
    { amountAllowance, isNeedApprove, isLoadingCheck, txHashApprove },
    fetchCheck,
    fecthApprove,
  ] = useCheckIsNeedApprove();
  const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";
  const {
    app,
    db,
    isLoading,
    dataLists,
    referralCode,
    parentReferral,
    putData,
    putDataReferral,
    getData,
    getTransaction,
    updateData,
    getRow,
    getReferralCode,
    getParentReferral,
  } = useSupabase();
  const [availableReward, setAvailableReward] = useState("0");
  const [availableRewardInToken, setAvailableRewardInToken] = useState("0");
  const [totalClaimedInDollar, setTotalClaimedInDollar] = useState("0");
  const [totalClaimedInToken, setTotalClaimedInToken] = useState("0");
  const [dividendOfReferrer, setDividendOfReferrer] = useState("0");
  const [dividendOfReferrerInToken, setDividendOfReferrerInToken] =
    useState("0");

  const [totalClaimedReferrerInDollar, setTotalClaimedReferrerInDollar] =
    useState("0");
  const [totalClaimedReferrerInToken, setTotalClaimedReferrerInToken] =
    useState("0");
  const [referralCount, setReferralCount] = useState(0);
  const [stakeDuration, setStakeDuration] = useState(0);

  const [totalSupply, setTotalSupply] = useState(0);

  const searchParams = new URLSearchParams(document.location.search);

  const [priceUSD, setPriceUSD] = useState(0);
  const [priceUSDChange, setPriceUSDChange] = useState(0);
  const [volumeUSD24h, setVolumeUSD24h] = useState(0);

  useEffect(() => {
    if (!isConnected || !address) return;
    initialize();
  }, [
    chainId,
    isConnected,
    address,
    tokenDecimalUSDT,
    tokenBalanceStake,
    tokenBalanceOpc,
  ]);

  const fetchTransactions = async () => {
    getTransaction(address, chainId, "OPENCOIN_STAKE_LONG").then((res) => {
      setTransactions(res.data);
    });
  };

  const initialize = () => {
    fetchCheck(
      getAppByChainId(chainId).USDT_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS
    ).then();
    getUSDTBalance(getAppByChainId(chainId).USDT_ADDRESS);
    getStakeBalance(getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS);
    getOpcBalance(getAppByChainId(chainId).TOKEN_ADDRESS);
    fetchTokenInfoStake(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS
    ).then();
    fetchTokenInfoUSDT(getAppByChainId(chainId).USDT_ADDRESS).then();
    fetchTokenInfoOpc(getAppByChainId(chainId).TOKEN_ADDRESS).then();
    getMinimumStakeInDollars();
    getTotalPeriod();

    getTotalSupply();
    fetchTransactions().then();
    getAvailableReward();
    getTotalClaimed();
    getReferralCode(address).then();
    getParentReferral(searchParams.get("ref")).then();
    getDividendOfReferrer();
    getTotalClaimedReferrer();
    getReferralCount();
    getStakeDuration();
    fetchTokenData().then();
  };

  const handleOnMaxHalfMin = (type) => {
    const availableAmount = usdtBalance;
    if (type === "max") {
      setAmountStake(availableAmount);
    } else if (type === "half") {
      setAmountStake(availableAmount / 2);
    } else if (type === "min") {
      setAmountStake(minimumStakeInDollars);
    }
  };

  const getDividendOfReferrer = () => {
    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "dividendOfReferrer",
      [ethers.utils.getAddress(address)]
    ).then((res) => {
      const balance = new BigNumber(res.toString());
      const formattedBalance = balance.div(10 ** tokenDecimalUSDT).toNumber();
      setDividendOfReferrer(formattedBalance.toString());

      dynamicCall(
        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
        "getEstimateTokenAmount",
        [res.toString()]
      ).then((res) => {
        setDividendOfReferrerInToken(
          ethers.utils.formatUnits(res.toString()).toString()
        );
      });
    });
  };

  // Fungsi baru untuk mengambil referral count tanpa looping useEffect
  const getReferralCount = () => {
    if (!isConnected || !address) {
      setReferralCount(0);
      return;
    }
    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "totalReferrer",
      [ethers.utils.getAddress(address)]
    )
      .then((res) => {
        setReferralCount(res?.toString?.() ?? "0");
      })
      .catch(() => setReferralCount(0));
  };

  // Fungsi baru untuk mengambil stake duration tanpa looping useEffect
  const getStakeDuration = () => {
    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "stakeDurationInHours",
      []
    )
      .then((res) => {
        setStakeDuration(res?.toString?.() ?? "0");
      })
      .catch(() => setStakeDuration(0));
  };

  const getMinimumStakeInDollars = () => {
    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "minimumStakeInDollars",
      []
    ).then((res) => {
      const balance = new BigNumber(res.toString());
      const formattedBalance = balance.div(10 ** tokenDecimalUSDT).toNumber();
      setMinimumStakeInDollars(formattedBalance.toString());
    });
  };

  const getAvailableReward = () => {
    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "dividendOf",
      [ethers.utils.getAddress(address)]
    ).then((res) => {
      const balance = new BigNumber(res.toString());
      const formattedBalance = balance.div(10 ** 6).toNumber();
      setAvailableReward(formattedBalance.toString());

      dynamicCall(
        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
        "getEstimateTokenAmount",
        [res.toString()]
      ).then((res) => {
        const balance = new BigNumber(res.toString());
        const formattedBalance = balance.div(10 ** 6).toNumber();
        setAvailableRewardInToken(
          ethers.utils.formatUnits(res.toString()).toString()
        );
      });
    });
  };

  const getTotalSupply = () => {
    dynamicCall(
      getAppByChainId(chainId).TOKEN_ADDRESS,
      getAppByChainId(chainId).ERC20_ABI,
      "totalSupply",
      []
    ).then((res) => {
      const res2 = res / 1000000000000000000;
      setTotalSupply(res2);
    });
  };

  const getTotalClaimed = () => {
    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "getTotalClaimedInDollarOf",
      [ethers.utils.getAddress(address)]
    ).then((res) => {
      const balance = new BigNumber(res.toString());
      const formattedBalance = balance.div(10 ** tokenDecimalUSDT).toNumber();
      setTotalClaimedInDollar(formattedBalance.toString());
    });

    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "getTotalClaimedInTokenOf",
      [ethers.utils.getAddress(address)]
    ).then((res) => {
      setTotalClaimedInToken(
        ethers.utils.formatUnits(res.toString()).toString()
      );
    });
  };

  const getTotalClaimedReferrer = () => {
    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "getTotalClaimedReferrerOf",
      [ethers.utils.getAddress(address)]
    ).then((res) => {
      const balance = new BigNumber(res.toString());
      const formattedBalance = balance.div(10 ** tokenDecimalUSDT).toNumber();
      setTotalClaimedReferrerInDollar(formattedBalance.toString());
    });

    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "getTotalClaimedReferrerInTokenOf",
      [ethers.utils.getAddress(address)]
    ).then((res) => {
      setTotalClaimedReferrerInToken(
        ethers.utils.formatUnits(res.toString()).toString()
      );
    });
  };

  const getTotalPeriod = () => {
    dynamicCall(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "getTotalPeriodOf",
      [ethers.utils.getAddress(address)]
    ).then((res) => {
      // console.log("Total Period Stake: ", res);
    });
  };

  const handleOnSubmit = () => {
    let referralAddress = parentReferral || ADDRESS_ZERO;
    if (referralAddress === address) {
      referralAddress = ADDRESS_ZERO;
    }

    if (referralAddress !== ADDRESS_ZERO) {
    }
    putData(
      "fyt_transactions",
      {
        key: "0x",
        account: address,
        chain_id: chainId,
        amount: ethers.utils
          .parseUnits(amountStake, tokenDecimalUSDT)
          .toString(),
        amount_symbol: tokenSymbolUSDT,
        hash: "0x",
        type: "Stake",
        data: {
          amount: ethers.utils
            .parseUnits(amountStake, tokenDecimalUSDT)
            .toString(),
          amount_symbol: tokenSymbolUSDT,
          address: ethers.utils.getAddress(address),
          referral_address: ethers.utils.getAddress(referralAddress),
          start_date: Math.floor(Date.now() / 1000),
        },
        service: "OPENCOIN_STAKE_LONG",
      },
      "hash"
    ).then((response) => {
      const dbId = response[0]?.id;
      dynamicSend(
        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
        "stake",
        [
          ethers.utils.parseUnits(amountStake, tokenDecimalUSDT),
          ethers.utils.getAddress(referralAddress),
          dbId.toString(),
        ],
        ethers.utils.parseUnits(amountStake, tokenDecimalUSDT),
        tokenSymbolUSDT,
        false
      )
        .then((res) => {
          initialize();
          toast.success("Stake Success");

          updateData(
            "fyt_transactions",
            {
              key: res.txHash,
              account: address,
              chain_id: chainId,
              amount: ethers.utils
                .parseUnits(amountStake, tokenDecimalUSDT)
                .toString(),
              amount_symbol: tokenSymbolUSDT,
              hash: res.txHash,
              type: "Stake",
              data: {
                amount: ethers.utils
                  .parseUnits(amountStake, tokenDecimalUSDT)
                  .toString(),
                amount_symbol: tokenSymbolUSDT,
                address: ethers.utils.getAddress(address),
                referral_address: ethers.utils.getAddress(referralAddress),
                start_date: Math.floor(Date.now() / 1000),
              },
              service: "OPENCOIN_STAKE_LONG",
            },
            dbId
          ).then((res) => {
            initialize();
          });

          putDataReferral(
            "fyt_referal_childs",
            {
              address: address,
              amount_reward: 0,
              amount_stake: ethers.utils
                .parseUnits(amountStake, tokenDecimalUSDT)
                .toString(),
              amount_symbol: tokenSymbolUSDT,
              direct_sponsor: referralAddress,
              service: "OPENCOIN_STAKE_LONG",
              hash: res.txHash,
            },
            "hash"
          );
          // store data for referrer
          // alert(res.txHash)
        })
        .catch((err) => {
          toast.error("Stake Failed");
          toast.error(err.message);
        });
    });
  };

  const handleOnClaimReward = () => {
    dynamicSend(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "claimDividend",
      [],
      null,
      tokenSymbolUSDT,
      false
    ).then((res) => {
      initialize();
    });
  };

  const handleOnClaimRewardReferrer = () => {
    dynamicSend(
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
      getAppByChainId(chainId).OPENCOINSTAKE_LONG_ABI,
      "claimDividendReferrer",
      [],
      null,
      tokenSymbolUSDT,
      false
    ).then((res) => {
      initialize();
    });
  };

  const fetchTokenData = async () => {
    try {
      const response = await axios.get(
        "https://api.geckoterminal.com/api/v2/networks/bsc/tokens/0x1F19c26a7F9b7A673348258d2fef0B7dF1Edef32/pools?page=1"
      );
      setPriceUSD(response.data?.data[0]?.attributes?.token_price_usd);
      setPriceUSDChange(
        response.data?.data[0]?.attributes?.price_change_percentage?.h24
      );
      setVolumeUSD24h(response.data.data[0]?.attributes?.volume_usd?.h24);
    } catch (error) {
      console.error("Error fetching token data:", error);
    }
  };

  return (
    <>
      <Header />
      <section className="relative px-4 py-4 overflow-hidden bg-white md:px-12 lg:px-28 dark:bg-grayc-950 md:py-20 lg:py-20 font-body">
        <div className="w-full p-6 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
          <div className="flex flex-col items-center justify-between w-full lg:flex-row md:flex-col xl:flex-row">
            <div className="flex justify-center md:justify-start items-center gap-8 flex-wrap">
              <div className="flex items-center gap-3">
                <img
                  src="/images/icon-reward/opc-coin.png"
                  width="60px"
                  height="60px"
                  alt="opencoin"
                />
                <div className="space-y-1">
                  <h1 className="text-lg font-semibold">
                    Open Coin <span>(OPC)</span>
                  </h1>
                  <div className="flex items-center gap-3">
                    ${Number(priceUSD).toFixed(2)}{" "}
                    <span
                      className={`flex items-center gap-1 ${
                        priceUSDChange < 0
                          ? "text-red-500"
                          : priceUSDChange === 0
                          ? "text-gray-500"
                          : "text-green-500"
                      }`}
                    >
                      {priceUSDChange < 0 ? (
                        <RiArrowDownLine />
                      ) : (
                        <RiArrowUpLine />
                      )}{" "}
                      {priceUSDChange}%
                    </span>
                  </div>
                </div>
              </div>
              <div className="space-y-1">
                <h1 className="text-lg font-semibold">{t("market cap")}</h1>
                <div className="flex items-center gap-3">
                  ${Number(totalSupply * priceUSD).toFixed(2)}
                </div>
              </div>
              <div className="space-y-1">
                <h1 className="text-lg font-semibold">{t("24h volume")}</h1>
                <div className="flex items-center gap-1">
                  <img
                    src="/images/icon-reward/opc-coin.png"
                    width="25px"
                    height="25px"
                    alt="opencoin"
                  />{" "}
                  ${Number(volumeUSD24h).toFixed(2)}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-4 mt-6 xl:mt-0 lg:mt-0 md:mt-6">
              <a
                href={`https://bscscan.com/token/${
                  getAppByChainId(chainId).TOKEN_ADDRESS
                }}`}
                target="_blank"
                rel="noreferrer"
                className="px-4 md:px-6 py-3 md:py-4 font-semibold text-center text-white rounded-xl bg-blue-500 dark:bg-blue-600 hover:bg-blue-900 dark:hover:bg-blue-500 dark:hover:text-gray-900"
              >
                {t("token contract")}
              </a>
              <a
                href="https://www.okx.com/web3/dex-swap?inputChain=56&inputCurrency=0x55d398326f99059ff775485246999027b3197955&outputChain=56&outputCurrency=0x1f19c26a7f9b7a673348258d2fef0b7df1edef32"
                target="_blank"
                rel="noreferrer"
                className="px-4 md:px-6 py-3 md:py-4 font-semibold text-center text-gray-900 bg-white rounded-xl hover:bg-gray-200 dark:hover:bg-grayc-950 dark:hover:text-white"
              >
                {t("buy opencoin")}
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-between w-full gap-10 mt-12 md:flex-row lg:flex-row xl:flex-row">
          <div className="w-full md:w-6/12 lg:w-6/12 xl:w-6/12">
            <div className="w-full p-6 xl:space-y-2.5 lg:space-y-2 md:space-y-3 space-y-4 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
              <div className="flex items-center justify-between">
                <div>{t("opencoin address")}</div>
                <div className="flex items-center gap-1 text-end">
                  <div className="flex items-center gap-2 px-3 py-1 font-bold bg-white border border-[#e3e3e4] dark:border-grayc-700 dark:bg-grayc-900 rounded-md">
                    <img
                      src="/images/icon-reward/bnb.svg"
                      width="15px"
                      height="15px"
                      alt="bsc"
                    />
                    <>
                      <a
                        href={`${getAppByChainId(chainId).URL_EXPLORER}/token/${
                          getAppByChainId(chainId).TOKEN_ADDRESS
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="opencoin"
                        className="flex items-center gap-1 text-blue-700 dark:hover:text-blue-500 hover:text-blue-500"
                      >
                        {truncate(
                          getAppByChainId(chainId).TOKEN_ADDRESS,
                          4,
                          "...",
                          50
                        )}
                        <RiExternalLinkLine />
                      </a>
                      <ClipboardCopy
                        copyText={getAppByChainId(chainId).TOKEN_ADDRESS}
                      />
                    </>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div>{t("stake address")}</div>
                <div className="flex items-center gap-1 text-end">
                  <div className="flex items-center gap-2 px-3 py-1 font-bold bg-white border border-[#e3e3e4] dark:border-grayc-700 dark:bg-grayc-900 rounded-md">
                    <img
                      src="/images/icon-reward/bnb.svg"
                      width="15px"
                      height="15px"
                      alt="bsc"
                    />
                    <>
                      <a
                        href={`${getAppByChainId(chainId).URL_EXPLORER}/token/${
                          getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="opencoin"
                        className="flex items-center gap-1 text-blue-700 dark:hover:text-blue-500 hover:text-blue-500"
                      >
                        {truncate(
                          getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
                          4,
                          "...",
                          50
                        )}
                        <RiExternalLinkLine />
                      </a>
                      <ClipboardCopy
                        copyText={truncate(
                          getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS
                        )}
                      />
                    </>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div>{t("USDT address")}</div>
                <div className="flex items-center gap-1 text-end">
                  <div className="flex items-center gap-2 px-3 py-1 font-bold bg-white border border-[#e3e3e4] dark:border-grayc-700 dark:bg-grayc-900 rounded-md">
                    <img
                      src="/images/icon-reward/bnb.svg"
                      width="15px"
                      height="15px"
                      alt="bsc"
                    />
                    <>
                      <a
                        href={`${getAppByChainId(chainId).URL_EXPLORER}/token/${
                          getAppByChainId(chainId).USDT_ADDRESS
                        }`}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="opencoin"
                        className="flex items-center gap-1 text-blue-700 dark:hover:text-blue-500 hover:text-blue-500"
                      >
                        {truncate(
                          getAppByChainId(chainId).USDT_ADDRESS,
                          4,
                          "...",
                          50
                        )}
                        <RiExternalLinkLine />
                      </a>
                      <ClipboardCopy
                        copyText={truncate(
                          getAppByChainId(chainId).USDT_ADDRESS
                        )}
                      />
                    </>
                  </div>
                </div>
              </div>

              <div className="relative flex py-5 items-center">
                <div className="flex-grow border-t border-gray-400"></div>
                <span className="flex-shrink mx-4 text-gray-900 dark:text-white">
                  Balance Information
                </span>
                <div className="flex-grow border-t border-gray-400"></div>
              </div>

              <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                <div>{t("Your USDT balance")}</div>
                <div className="flex items-center gap-1 text-end">
                  <img
                    src="/images/usdt.svg"
                    height="25px"
                    width="25px"
                    alt="usdt-small"
                  />
                  {formatNumericWithComma(usdtBalance)}
                </div>
              </div>

              <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                <div>{t("your opencoin balance")}</div>
                <div className="flex items-center gap-1 text-end">
                  <img
                    src="/images/icon-reward/opc-coin.png"
                    height="25px"
                    width="25px"
                    alt="opencoin-small"
                  />
                  {tokenBalanceOpc}
                </div>
              </div>

              <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                <div>{t("your referral count")}</div>
                <div className="flex items-center gap-1 text-end">
                  <RiUser3Line /> {referralCount}
                </div>
              </div>
              {/* Stake Duration */}
              <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                <div>{t("stake duration (hours)")}</div>
                <div className="flex items-center gap-1 text-end">
                  {stakeDuration}
                </div>
              </div>
              {/* End Stake Duration */}
            </div>

            <div className="w-full p-6 mt-12 space-y-3 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
              <div className="flex items-center justify-between w-full">
                <a
                  href="https://www.okx.com/web3/dex-swap?inputChain=56&inputCurrency=0x55d398326f99059ff775485246999027b3197955&outputChain=56&outputCurrency=0x1f19c26a7f9b7a673348258d2fef0b7df1edef32"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-1 text-black dark:text-white hover:text-blue-600 dark:hover:text-blue-500"
                >
                  <RiExchangeDollarLine />
                  <div className="font-semibold">{t("get opencoin")}</div>
                </a>
                <a
                  href="javascript:void(0)"
                  className="flex items-center gap-1 text-black dark:text-white hover:text-blue-600 dark:hover:text-blue-500"
                >
                  <RiTimer2Line />
                  <div className="font-semibold">{t("history")}</div>
                </a>
              </div>

              <div className="p-4 bg-white dark:bg-grayc-800 rounded-2xl">
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center gap-3">
                    <button
                      type="button"
                      className="px-6 py-1 text-sm text-gray-800 bg-gray-100 dark:bg-grayc-900 dark:text-grayc-100 border-grayc-400 dark:border-gray-900 hover:border-gray-700 dark:hover:border-grayc-500 rounded-xl"
                      onClick={() => handleOnMaxHalfMin("max")}
                    >
                      {t("max")}
                    </button>
                    <button
                      type="button"
                      className="px-6 py-1 text-sm text-gray-800 bg-gray-100 dark:bg-grayc-900 dark:text-grayc-100 border-grayc-400 dark:border-gray-900 hover:border-gray-700 dark:hover:border-grayc-500 rounded-xl"
                      onClick={() => handleOnMaxHalfMin("half")}
                    >
                      {t("half")}
                    </button>
                    <button
                      type="button"
                      className="px-6 py-1 text-sm text-gray-800 bg-gray-100 dark:bg-grayc-900 dark:text-grayc-100 border-grayc-400 dark:border-gray-900 hover:border-gray-700 dark:hover:border-grayc-500 rounded-xl"
                      onClick={() => handleOnMaxHalfMin("min")}
                    >
                      {t("min")}
                    </button>
                  </div>

                  <div className="flex items-center gap-2">
                    <RiWalletLine />0
                  </div>
                </div>

                <div className="flex items-center justify-between w-full gap-4 my-4">
                  <input
                    className="w-8/12 gap-2 px-4 py-2 bg-gray-100 xl:w-10/12 lg:w-10/12 md:w-8/12 border-grayc-600 dark:border-grayc-900 dark:bg-grayc-900 rounded-xl"
                    placeholder="0"
                    value={amountStake}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*\.?\d*$/.test(value)) {
                        setAmountStake(value);
                      }
                    }}
                  />
                  <div className="flex items-center w-4/12 gap-1 px-4 py-2 bg-gray-100 md:w-4/12 lg:w-2/12 xl:w-2/12 border-grayc-600 dark:border-gracy-900 dark:bg-grayc-900 rounded-xl">
                    <img
                      src="/images/usdt.svg"
                      width="25px"
                      height="25px"
                      alt="usdt-sm"
                    />
                    <div>USDT</div>
                  </div>
                </div>
                <div>
                  <small className={"text-red-800"}>
                    {t("invalid amount")}
                  </small>
                </div>
                <div className="flex items-center justify-start w-full my-4 gap-2">
                  <div>{t("minimum stake")}:</div>
                  <div>
                    <img
                      src="/images/usdt.svg"
                      width="25px"
                      height="25px"
                      alt="usdt-sm"
                    />
                  </div>

                  {formatNumericWithComma(minimumStakeInDollars)}
                </div>
              </div>

              {/* after approve button */}
              <div className="flex items-center justify-between w-full gap-4 pt-3">
                {isNeedApprove && (
                  <button
                    type="button"
                    className={
                      "w-full flex items-center justify-center gap-2 px-6 py-3 text-center text-white rounded-3xl bg-blue-500 hover:bg-blue-600 hover:text-white"
                    }
                    onClick={() => {
                      fecthApprove(
                        getAppByChainId(chainId).USDT_ADDRESS,
                        getAppByChainId(chainId).OPENCOINSTAKE_LONG_ADDRESS,
                        amountStake
                      ).then();
                    }}
                    disabled={isLoadingCheck || isLoadingSend}
                  >
                    {t("approve")}
                    <div className={""}>
                      <ClipLoader
                        color={"#f59e0b"}
                        loading={isLoadingCheck || isLoadingSend}
                        size={20}
                      />
                    </div>
                  </button>
                )}
                {!isNeedApprove && (
                  <button
                    type="button"
                    className={
                      "w-full flex items-center justify-center gap-2 px-6 py-3 text-center text-white rounded-3xl bg-blue-500 hover:bg-blue-600 hover:text-white"
                    }
                    onClick={() => {
                      handleOnSubmit();
                    }}
                    disabled={isLoadingCheck || isLoadingSend}
                  >
                    {t("stake")}
                    <ClipLoader
                      color={"#f59e0b"}
                      loading={isLoadingCheck || isLoadingSend}
                      size={20}
                    />
                  </button>
                )}
              </div>
              {/* end after approve button */}

              {/* before approve button */}
              {/*<div className="flex items-center justify-between w-full gap-4 pt-3">*/}
              {/*  <button*/}
              {/*    type="button"*/}
              {/*    className={*/}
              {/*      "w-full flex items-center justify-center gap-2 px-6 py-3 text-center text-white rounded-3xl bg-blue-500 hover:bg-blue-600 hover:text-white"*/}
              {/*    }*/}
              {/*  >*/}
              {/*    {t("stake")}*/}
              {/*  </button>*/}
              {/*  <button*/}
              {/*    type="button"*/}
              {/*    className={*/}
              {/*      "w-full flex items-center justify-center gap-2 px-6 py-3 text-center text-white rounded-3xl bg-grayc-900 hover:bg-grayc-950 hover:text-gray-200"*/}
              {/*    }*/}
              {/*  >*/}
              {/*    <ClipLoader color={"#f59e0b"} loading={true} size={20} />*/}

              {/*    {t("approve")}*/}
              {/*  </button>*/}
              {/*</div>*/}
              {/* end before approve button */}

              {/* before connect wallet button */}
              {/*<div className="flex items-center justify-between w-full gap-4 pt-3">*/}
              {/*  <button*/}
              {/*    type="button"*/}
              {/*    className={*/}
              {/*      "w-full flex items-center justify-center gap-2 px-6 py-3 text-center text-grayc-500 rounded-3xl bg-white hover:bg-white hover:text-gray-900"*/}
              {/*    }*/}
              {/*  >*/}
              {/*    {t("connect wallet first")}*/}
              {/*  </button>*/}
              {/*</div>*/}
              {/* end before connect wallet button */}
            </div>
          </div>
          <div className="w-full md:w-6/12 lg:w-6/12 xl:w-6/12">
            <div className="w-full p-6 space-y-3 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
              <h1 className="mb-5 text-lg font-semibold">
                {t("stake information")}
              </h1>
              <div className="space-y-3">
                <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("stake amount")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <img
                      src="/images/icon-reward/opc-coin.png"
                      height="25px"
                      width="25px"
                      alt="opencoin-small"
                    />
                    {tokenBalanceStake}
                  </div>
                </div>
                <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("available reward")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <div className={"me-4 flex gap-2"}>
                      <img
                        src="/images/usdt.svg"
                        height="25px"
                        width="25px"
                        alt="opencoin-small"
                      />
                      {availableReward}
                    </div>
                    ~
                    <div className={"me-4 flex gap-2"}>
                      <img
                        src="/images/icon-reward/opc-coin.png"
                        height="25px"
                        width="25px"
                        alt="opencoin-small"
                      />
                      {availableRewardInToken}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("claimed reward")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <div className={"me-4 flex gap-2"}>
                      <img
                        src="/images/usdt.svg"
                        height="25px"
                        width="25px"
                        alt="opencoin-small"
                      />
                      {totalClaimedInDollar}
                    </div>
                    ~
                    <div className={"me-4 flex gap-2"}>
                      <img
                        src="/images/icon-reward/opc-coin.png"
                        height="25px"
                        width="25px"
                        alt="opencoin-small"
                      />
                      {totalClaimedInToken}
                    </div>
                  </div>
                </div>
                {/*<div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">*/}
                {/*  <div>{t("claim count")}</div>*/}
                {/*  <div className="flex items-center gap-1 text-end">*/}
                {/*    <img*/}
                {/*      src="/images/icon-reward/opc-coin.png"*/}
                {/*      height="25px"*/}
                {/*      width="25px"*/}
                {/*      alt="opencoin-small"*/}
                {/*    />*/}
                {/*    0*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>

              <div className="flex gap-4 pt-3">
                <button
                  type="button"
                  className="flex items-center gap-2 px-8 py-3 text-white bg-blue-500 hover:bg-blue-600 rounded-xl"
                  disabled={isLoadingCheck || isLoadingSend}
                  onClick={() => handleOnClaimReward()}
                >
                  <div>{t("claim reward")}</div>
                  <ClipLoader
                    color={"#f59e0b"}
                    loading={isLoadingCheck || isLoadingSend}
                    size={20}
                  />
                </button>
              </div>
            </div>

            <div className="w-full p-6 mt-12 space-y-3 text-black bg-gray-100 dark:bg-grayc-900 dark:text-white rounded-2xl">
              <h1 className="mb-5 text-lg font-semibold">
                {t("referral information")}
              </h1>
              <div className="space-y-3" key={referralCode}>
                <div className="flex items-center justify-start w-full">
                  <div className="px-6 py-3 font-semibold text-white bg-blue-500 rounded-l-md whitespace-nowrap">
                    {t("referral link")}
                  </div>
                  <input
                    type="text"
                    className="w-full px-6 py-3 text-black bg-white dark:bg-grayc-950 dark:text-white"
                    placeholder={
                      window.location.origin +
                      `/opc-stake-long?ref=${referralCode}`
                    }
                    defaultValue={
                      window.location.origin +
                      `/opc-stake-long?ref=${referralCode}`
                    }
                  />
                  <button
                    className="flex items-center justify-center px-4 py-4 text-white bg-blue-500 hover:bg-blue-600 rounded-r-md"
                    type={"button"}
                    onClick={() =>
                      copyToClipboard(
                        toast,
                        window.location.origin +
                          `/opc-stake-long?ref=${referralCode}`
                      )
                    }
                  >
                    <RiFileCopy2Line />
                  </button>
                </div>
                <div></div>
                <div className="flex flex-col items-start justify-between pt-4 xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("reward")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <div>0.5 %</div>
                  </div>
                </div>
                <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("available reward")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <div className={"me-4 flex gap-2"}>
                      <img
                        src="/images/usdt.svg"
                        height="25px"
                        width="25px"
                        alt="opencoin-small"
                      />
                      {dividendOfReferrer}
                    </div>
                    ~
                    <div className={"me-4 flex gap-2"}>
                      <img
                        src="/images/icon-reward/opc-coin.png"
                        height="25px"
                        width="25px"
                        alt="opencoin-small"
                      />
                      {dividendOfReferrerInToken}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start justify-between xl:items-center lg:items-center md:items-start xl:flex-row lg:flex-row md:flex-col">
                  <div>{t("claimed reward")}</div>
                  <div className="flex items-center gap-1 text-end">
                    <div className={"me-4 flex gap-2"}>
                      <img
                        src="/images/usdt.svg"
                        height="25px"
                        width="25px"
                        alt="opencoin-small"
                      />
                      {totalClaimedReferrerInDollar}
                    </div>
                    ~
                    <div className={"me-4 flex gap-2"}>
                      <img
                        src="/images/icon-reward/opc-coin.png"
                        height="25px"
                        width="25px"
                        alt="opencoin-small"
                      />
                      {totalClaimedReferrerInToken}
                    </div>
                  </div>
                </div>
                <div className="flex gap-4 pt-3">
                  <button
                    type="button"
                    className="flex items-center gap-2 px-8 py-3 text-white bg-blue-500 hover:bg-blue-600 rounded-xl"
                    disabled={isLoadingCheck || isLoadingSend}
                    onClick={() => handleOnClaimRewardReferrer()}
                  >
                    <div>{t("claim reward")}</div>
                    <ClipLoader
                      color={"#f59e0b"}
                      loading={isLoadingCheck || isLoadingSend}
                      size={20}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto mt-12">
          <table className="min-w-full bg-white border border-gray-200 rounded-xl">
            <thead className="rounded-t-xl">
              <tr className="bg-gray-100 rounded-t-xl">
                <th className="px-6 py-4 rounded-tl-xl text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Stake Amount
                </th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Stake Start
                </th>
                <th className="px-6 py-4 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Stake End
                </th>

                <th className="px-6 py-4 text-left text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Stake TxHash
                </th>
                <th className="px-6 py-4 text-right text-xs font-medium text-gray-800 uppercase tracking-wider">
                  Dividend
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {transactions.length === 0 ? (
                <tr>
                  <td
                    colSpan={5}
                    className="px-6 py-4 text-center text-gray-400"
                  >
                    No transactions found.
                  </td>
                </tr>
              ) : (
                transactions.map((tx) => (
                  <TableRow
                    key={tx.id}
                    tx={tx}
                    tokenDecimalUSDT={tokenDecimalUSDT}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>
      <Footer />
    </>
  );
}
